document.addEventListener("DOMContentLoaded", function () {
  const openButtons = document.querySelectorAll("[data-open-modal]");
  const closeButtons = document.querySelectorAll("[data-close-modal]");
  const modalWrapper = document.querySelector(".modal-wrapper");
  const modalVideo = document.getElementById("modal-video");
  const stickyHeader = document.querySelector(".mega-sticky-header");

  // Open modal + play video
  openButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      modalWrapper.classList.remove("is-hidden");
      modalWrapper.classList.add("is-active");
      modalWrapper.setAttribute("aria-hidden", "false");
      document.body.classList.add("overflow-hidden");

      // hide sticky header
      if (stickyHeader) stickyHeader.style.display = "none";

      // reset + play video
      modalVideo.currentTime = 0;
      modalVideo.play();
    });
  });

  // Close modal
  function closeModal() {
    modalVideo.pause();
    modalWrapper.classList.remove("is-active");
    modalWrapper.classList.add("is-hidden");
    modalWrapper.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");

    // show sticky header again
    if (stickyHeader) stickyHeader.style.display = "";
  }

  closeButtons.forEach((btn) => {
    btn.addEventListener("click", closeModal);
  });

  modalWrapper.addEventListener("click", function (e) {
    if (e.target.dataset.closeModal !== undefined) {
      closeModal();
    }
  });

  document.addEventListener("keyup", function (e) {
    if (e.key === "Escape") {
      closeModal();
    }
  });
});
